var a=0,r=function(){var r=++a;return"".concat(r)};export{r as default};
